<template>
    <div id="paper" class="flow-graph">
        <svg width="1140" />
    </div>
</template>

<script>
import { createGraph } from './utils';

export default {
    name: 'FlowGraph',
    props: {
        transitions: {
            required: true,
            type: Array
        },
        flow: {
            required: true,
            type: Object
        },
        states: {
            required: true,
            type: Array
        }
    },

    mounted() {
        createGraph('#paper svg', this.transitions, this.states, this.flow);
    }
};
</script>

<style lang="scss" src="./FlowGraph.scss"></style>
